<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (value) {
      <ng-container i18n>Wert bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Wert hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <div>
        <mat-form-field>
          <mat-label i18n>Deutscher Name</mat-label>
          <input matInput type="text" formControlName="nameDe" />
        </mat-form-field>
        <mat-form-field>
          <mat-label i18n>Englischer Name</mat-label>
          <input matInput type="text" formControlName="nameEn" />
        </mat-form-field>
      </div>

      <div class="buttons-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" (click)="close()" [disabled]="formGroup.disabled" i18n>Verwerfen</button>
        @if (value) {
          <button mat-stroked-button color="warn" type="button" (click)="delete()" [disabled]="formGroup.disabled" i18n
            >Wert löschen</button
          >
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
